import i18n from '../i18n';

/**
 * Resolves an AI generation error code to a localized user-friendly message.
 * Falls back to a generic error message if the code is unknown or missing.
 *
 * @param errorCode The error code returned from the BFF (e.g. RESOURCE_EXHAUSTED, rate_limit_exceeded)
 * @param fallbackKey The i18n key to use if the error code is not found
 * @returns The localized error message
 */
export function resolveAIGenerationError(
    errorCode?: string | number | null,
    fallbackKey = 'mannequin.aiGeneration.errors.generationFailed'
): string {
    if (!errorCode) {
        return i18n.t(fallbackKey);
    }

    const codeStr = String(errorCode)
        .replace(/[_-\s]/g, '')
        .toLowerCase();
    const translationKey = `mannequin.aiGeneration.providerErrors.${codeStr}`;

    if (i18n.exists(translationKey)) {
        return i18n.t(translationKey);
    }

    return i18n.t(fallbackKey);
}
export function resolveAIGenerationFailureMessage(
    errorCode?: string | number | null,
    errorMessage?: string | null,
    fallbackKey = 'mannequin.aiGeneration.errors.generationFailed'
): string {
    const trimmedMessage = errorMessage?.trim();
    if (trimmedMessage) {
        return trimmedMessage;
    }

    return resolveAIGenerationError(errorCode, fallbackKey);
}
